import { AuthorModel } from './models/AuthorModel';
import { hasAuthors, hasCustomAuthors } from '../../../constants/GlobalHelpers';
import { fetchAuthorById } from './http/AuthorHttp';
import { normalizeAuthor } from './normalizers/AuthorNormalizer';

export const getAuthorById = async (id: string): Promise<AuthorModel | null> => {
    try {
        const response = await fetchAuthorById(id);
        return normalizeAuthor(response);
    } catch (e) {
        return null;
    }
};

export const mergeAuthorsWithCustomAuthor = (
    authors: AuthorModel[],
    customAuthor: string,
    separator: string = ', ',
): string => {
    const authorsList = listAuthors(authors, separator);

    if (!hasAuthors(authors) && hasCustomAuthors(customAuthor)) {
        //If there aren't any authors added and a custom author is available return the custom author
        return customAuthor;
    } else if (hasAuthors(authors) && hasCustomAuthors(customAuthor)) {
        //If there are authors available and also a custom author merge and return all
        return `${authorsList}${separator}${customAuthor}`;
    } else if (hasAuthors(authors) && !hasCustomAuthors(customAuthor)) {
        //If there are
        return authorsList;
    }

    return '';
};
export const listAuthors = (authors: AuthorModel[], separator: string = ', '): string => {
    if (hasAuthors(authors)) {
        if (authors.length === 0) {
            return authors[0].name;
        } else {
            const authorNames = authors.map((author) => author.name);
            return authorNames.join(separator);
        }
    }

    return '';
};
